import React, { useEffect } from 'react'
import cn from 'classnames'
import { Route, Routes, useNavigate, useLocation, Link } from 'react-router-dom'
import DefaultLayout from '../../components/DefaultLayout'
import Footer from '../../components/Footer/Footer'
import PartnerRedeemPage from './PartnerRedeemPage'
import Logo from '../../components/Logo'
import PartnerHeader from './PartnerHeader'
import PartnerHero from './PartnerHero'
import AccountFlow from '../../components/AccountFlow/AccountFlow'
import {
  setEntryPoint,
  trackStartRegistration,
  trackViewLandingPage,
} from 'js/analytics/tracking'

// TODO: remove this temporary workaround. This is a workaround for the redux
// store types not being setup yet.
type PartnerRedeemPageProps = {
  partnerBoxClasses: string
} & Props

const TypeCastPartnerRedeemPage = PartnerRedeemPage as (
  props: PartnerRedeemPageProps,
) => React.ReactElement

type Props = {
  children: React.ReactNode
  ctaButton: React.ReactNode
  ctaButtonText?: React.ReactNode
  heroGradient?: string
  heroHeading: React.ReactNode
  heroImage: string
  heroImageMobile: string
  heroSubHeading?: React.ReactNode
  languages?: string[]
  partner: string
  partnerLogo: {}
  rootUrl: string
  callout?: React.ReactNode
  couponPrefix?: string
  defaultGoal?: string
  forcedGoal?: boolean
  heroMessage?: React.ReactNode
  hideCoupon?: boolean
  initialPlan?: 1 | 3 | 6 | 12 | 24
  introText?: React.ReactNode
}

function Home(props: Props) {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    setEntryPoint('Partner')
    trackViewLandingPage()
  }, [])

  return (
    <>
      <div className={cn('relative', 'partner', props.partner)}>
        <PartnerHeader
          partner={props.partner}
          partnerLogo={props.partnerLogo}
          transparent
          onLanguageChange={(code) =>
            code !== 'en'
              ? navigate(`/${code}${props.rootUrl}`)
              : navigate(props.rootUrl)
          }
          languages={props.languages || undefined}
        />
        <PartnerHero
          partner={props.partner}
          heroImage={props.heroImage}
          heroImageMobile={props.heroImageMobile}
          heroGradient={props.heroGradient}
          heading={props.heroHeading}
          subHeading={props.heroSubHeading}
          ctaButton={props.ctaButton}
          rootUrl={location.pathname}
        />

        <div id="start">{props.children}</div>
      </div>
      <Footer marginless showCareers={false} />
    </>
  )
}

function PartnerPage(props: Props) {
  const location = useLocation()
  const rootUrl = location.pathname.replace(/\/redeem\/?/, '')
  const partnerBoxClasses =
    'bg-white pt-40 px-40 pb-24 rounded-8 mx-auto relative max-w-512'

  return (
    <DefaultLayout>
      <Routes>
        <Route
          path="redeem"
          element={
            <div className="c-upgrade">
              <div className="c-upgrade__header">
                <Link to={rootUrl}>
                  <Logo />
                </Link>
              </div>
              <div className="o-width-limiter">
                <TypeCastPartnerRedeemPage
                  partnerBoxClasses={partnerBoxClasses}
                  {...props}
                />
              </div>
            </div>
          }
        />
        <Route
          path="account"
          element={
            <div className="c-upgrade">
              <div className="c-upgrade__header">
                <Link to={rootUrl}>
                  <Logo />
                </Link>
              </div>
              <div className="o-width-limiter">
                <AccountFlow
                  defaultGoal={props.defaultGoal}
                  forcedGoal={props.forcedGoal}
                  hideCoupon={props.hideCoupon}
                  scenario="partner"
                  onSignUpClick={() => {
                    trackStartRegistration()
                  }}
                  initialPlan={props.initialPlan}
                />
              </div>
            </div>
          }
        />
        <Route path="*" element={<Home {...props} />} />
      </Routes>
    </DefaultLayout>
  )
}

export default PartnerPage
